module.exports = __webpack_public_path__ + "img/tutorial03.da928413.png";